import { css } from 'styled-components';

export const DarkKnightSkin = css`
  background-color: #1a1a1a;
  border: 1px solid #333;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
`;

export const DarkKnightWrapperSkin = css`
  background: linear-gradient(180deg, #2c2c2c 0%, #0d0d0d 100%);
`;

export const DarkKnightLetterSkin = css<{ $isActive: boolean }>`
  color: ${props => (props.$isActive ? '#ffffff' : '#c6c6c6')};
  opacity: ${props => (props.$isActive ? 1 : 0.1)};
`;
